import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import { PageBreadcrumb } from "../../../../core/common/BreadCrumbForm";
import Datatable from "../../../../core/common/dataTable/index";
import { ColumnsType } from "antd/es/table";
import { parseNumber, safeLocaleCompare } from "../../../../core/methods/sorterMethods"; 
import useApi from "../../../../core/customhook/useApi";
import webservice_url from "../../../../core/webservice/Webservice_url";
import { PaginationType } from "../../../../types/common-type";
import useLocalStorage from "../../../../core/customhook/hooks/useLocalStorage";
import Loading from "../../../../core/common/custom-loading/Loading";
import { getSearchableHeader } from "../../../../core/utils/getSearchableHeader";

// breadcrumb data
const breadcrumbItem = [
  { label: "Manage Verifier" },
];

const Admin_ManageVerifier = () => {
  const navigate = useNavigate();
  const { setLocalStorage } = useLocalStorage();
  const [inventoryColumnSearch, setInventoryColumnSearch] = useState<
    Record<string, string>
  >({});
  const [allItemList, setAllItemList] = useState<any[]>([]); 

  type InviteItem = any;
  const filteredData = (Array.isArray(allItemList) ? allItemList : []).filter(
    (item: InviteItem) => {
      return Object.entries(inventoryColumnSearch).every(([key, value]) => {
        if (!value) return true;

        return String(item[key as keyof InviteItem] ?? "")
          .toLowerCase()
          .includes(value.toLowerCase());
      });
    },
  );
  const [pagination, setPagination] = useState<PaginationType>({
    current: 1,
    pageSize: 1000, // limit of records
    total: 0,
  });


  // ---- API ----
  const { callApi, loading: loading_getList } = useApi<any>(webservice_url.get_all_verifiers, {
    method: "GET",
    autoCall: false,
    handleGlobalError: false,
  });

 
  const columns: ColumnsType<any> = [
  {
    title: "S.No",
    dataIndex: "sno",
    align: "center",
    render: (text: string, record: any, index: number) => index + 1,
    sorter: false,
  },
  {
    title: getSearchableHeader("Verifier Name", "verifier_name", setInventoryColumnSearch),
    dataIndex: "verifier_name",
    render: (text: string) => (
      <div className="text-capitalize">{text ?? "-"}</div>
    ),
    sorter: (a: any, b: any) => safeLocaleCompare(a, b, "verifier_name"),
  },
  {
    title: getSearchableHeader("Contact", "phone", setInventoryColumnSearch),
    dataIndex: "phone",
    sorter: (a: any, b: any) => parseNumber(a.phone) - parseNumber(b.phone),
  },
  {
    title: getSearchableHeader("Email", "email", setInventoryColumnSearch),
    dataIndex: "email",
    sorter: (a: any, b: any) => safeLocaleCompare(a, b, "email"),
  },
  {
    title: getSearchableHeader("Manager Name", "manager_name", setInventoryColumnSearch),
    dataIndex: "manager_name",
    sorter: (a: any, b: any) => safeLocaleCompare(a, b, "manager_name"),
  },
  {
    title: getSearchableHeader(
      "Manager Email",
      "manager_email",
      setInventoryColumnSearch,
    ),
    dataIndex: "manager_email",
    sorter: (a: any, b: any) => safeLocaleCompare(a, b, "manager_email"),
  },
  {
    title: "Cases",
    dataIndex: "",
    align: "center",
    render: (text: string, record: any) => {
      return (
        <button
          type="button"
          className="btn btn-sm btn-tertiary py-0"
          onClick={() => {
            // storing in localstorage
            const verifierData = {
              name: record?.verifier_name ?? "",
              email: record?.email ?? "",
              mobile: record?.phone ?? "",

              //manager detail
              managerId: record?.manager_user_id ?? "",
              managerName: record?.manager_name ?? "",
              managerEmail: record?.manager_email ?? "",
              managerNumber: record?.manager_phone ?? "",
            };
            setLocalStorage("admin_selected_verifier", verifierData);

            navigate(
              `${all_routes.admin_verifier_cases}/${record.verifier_user_id}`,
            );
          }}
        >
          <i className="ti ti-eye"></i>
        </button>
      );
    },
  },
];
  
  const fetchData = async () => {
    try {
      const res = await callApi({
        page: pagination?.current ?? 1,
        limit: pagination?.pageSize ?? 10
      })
      if (res?.success) {
        const data = res?.data?.rows || [];
        setAllItemList(data)

        setPagination((prev) => ({
          ...prev,
          total: res?.data?.pagination?.totalRecords || 0
        }))
      }
    } catch (error: any) {
      console.error(error?.response)
    }
  }

  useEffect(() => {
    fetchData();
  }, [pagination?.current, pagination?.pageSize])
 
  const handleTableChange = (pgConfig: any) => {
    if (
      pgConfig.current !== pagination.current ||
      pgConfig.pageSize !== pagination.pageSize
    ) {
      setPagination((prev) => ({
        ...prev,
        current: pgConfig.current,
        pageSize: pgConfig.pageSize
      }))
    }
  }; 

  return (
    <div>
      <>
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            {/* PageBreadcrumb */}
            <PageBreadcrumb
              title="Manage Verifier"
              breadcrumbs={breadcrumbItem}
            // showExport={true}
            />
            {/* /PageBreadcrumb */}

            {/* Table */}
            <div className="card mt-3" style={{ minHeight: "250px" }}>
              {loading_getList ? <Loading /> :
                <Datatable
                  rowKey="verifier_user_id"
                  columns={columns}
                  dataSource={filteredData}
                  Selection={false}
                  pagination={pagination}
                  handleTableChange={handleTableChange}
                />
              }
            </div>

            {/* /Filter Section */}
            <div className="row align-items-center">
              <div className="col-md-12">
                <div className="datatable-paginate mt-4" />
              </div>
            </div>
          </div>
        </div>
        {/* /Page Wrapper */}
      </>
    </div>
  );
};

export default Admin_ManageVerifier;

// {/* Filter Section */}
// <div className="card">
//   <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
//     <h4 className="mb-3">Users List</h4>
//     <div className="d-flex align-items-center flex-wrap">
//       <div className="input-icon-start mb-3 me-2 position-relative">
//         <PredefinedDateRanges />
//       </div>
//       <div className="dropdown mb-3 me-2">
//         <Link
//           to="#"
//           className="btn btn-outline-light bg-white dropdown-toggle"
//           data-bs-toggle="dropdown"
//           data-bs-auto-close="outside"
//         >
//           <i className="ti ti-filter me-2" />
//           Filter
//         </Link>
//         <div
//           className="dropdown-menu drop-width"
//           ref={dropdownMenuRef}
//         >
//           <form>
//             <div className="d-flex align-items-center border-bottom p-3">
//               <h4>Filter</h4>
//             </div>
//             <div className="p-3 border-bottom">
//               <div className="row">
//                 <div className="col-md-12">
//                   <div className="mb-0">
//                     <label className="form-label">Users</label>
//                     <CommonSelect
//                       className="select"
//                       options={Reason}
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="p-3 d-flex align-items-center justify-content-end">
//               <Link to="#" className="btn btn-light me-3">
//                 Reset
//               </Link>
//               <Link
//                 to="#"
//                 className="btn btn-primary"
//                 onClick={handleApplyClick}
//               >
//                 Apply
//               </Link>
//             </div>
//           </form>
//         </div>
//       </div>
//       <div className="dropdown mb-3">
//         <Link
//           to="#"
//           className="btn btn-outline-light bg-white dropdown-toggle"
//           data-bs-toggle="dropdown"
//         >
//           <i className="ti ti-sort-ascending-2 me-2" />
//           Sort by A-Z
//         </Link>
//         <ul className="dropdown-menu p-2">
//           {["Ascending", "Descending", "Recently Viewed", "Recently Added"]?.map((d) => (
//             <li className="p-1">
//               <Link to="#" className={`dropdown-item rounded-1 active p-1`}>
//                 {d}
//               </Link>
//             </li>
//           ))}
//         </ul>
//       </div>
//     </div>
//   </div>
//   {/* User List */}
//   <div className="card-body p-0 py-3">
//     <Table columns={columns} dataSource={data} Selection={true} />
//   </div>
//   {/* /User List */}
// </div>